/* global axios */
import ApiClient from '../ApiClient';

class CaptainResponses extends ApiClient {
  constructor() {
    super('captain/assistant_responses', { accountScoped: true });
  }

  get({
    page = 1,
    search,
    assistantId,
    documentId,
    status,
    createdVia,
    responsibleId,
  } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search,
        assistant_id: assistantId,
        document_id: documentId,
        status,
        created_via: createdVia,
        responsible_id: responsibleId,
      },
    });
  }

  chunksExport({ assistantId } = {}) {
    return axios.get(`${this.url}/chunks_export`, {
      params: { assistant_id: assistantId },
    });
  }

  responsibles({ assistantId } = {}) {
    return axios.get(`${this.url}/responsibles`, {
      params: { assistant_id: assistantId },
    });
  }
}

export default new CaptainResponses();
